import React  from 'react';
import { PricesAccordionTab, PricesSectionType } from 'store/state/selectors/insights/prices';
import { ShowAt } from 'consts/breakpoints';
import { Text } from 'ds/components/typography';
import { useLocale } from 'locale';
import PricesTable from 'components/widget/prices/prices-table';
import { WIDGET_DESKTOP_TABLE_ROWS, WIDGET_MOBILE_TABLE_ROWS } from 'components/widget/prices/utils';

interface PricesTabsProps {
  tab: PricesAccordionTab;
  sectionId: PricesSectionType;
}

const PricesTabs: React.FC<PricesTabsProps> = props => {
  const { tab, sectionId } = props;
  const { t } = useLocale();
  return (
    <ShowAt at={1}>
      {matches => (
        <div>
          {tab.tableData.length ? (
            <PricesTable
              tab={tab}
              visibleRowsDesktop={WIDGET_DESKTOP_TABLE_ROWS}
              visibleRowsMobile={WIDGET_MOBILE_TABLE_ROWS}
            />
          ) : (
            <Text style={{ paddingBottom: matches ? '24px' : 0 }}>
              {sectionId === PricesSectionType.LocalHistory
                ? t('widget.prices.comparableTable.noData', { tab: tab.tabId })
                : t('widget.prices.noComparableMessage')}
            </Text>
          )}
        </div>
      )}
    </ShowAt>
  );
};

export default PricesTabs;
